import { memo } from 'react';
import DeleteIcon from './Delete';
import DuplicateIcon from './Duplicate';
import EditIcon from './Edit';
import ViewIcon from './View';
import MoreIcon from './More';
import DarwinUserIcon from './DarwinUser';
import UserOutlineIcon from './UserOutline';
import UserPlaceholderIcon from './UserPlaceholder';
import FlagIcon from './Flag';
import ChevronUp from './ChevronUp';
import EndOfFlow from './EndOfFlow';
import ChevronDown from './ChevronDown';
import CoolingIcon from './Cooling';
import LocationPinIcon from './LocationPin';
import PackingIcon from './Packing';
import ReceiverIcon from './Receiver';
import TruckIcon from './Truck';
import HarvestingIcon from './Harvesting';
import PlusIcon from './Plus';
import DocumentIcon from './Document';
import TestIcon from './Test';
import DeployIcon from './Deploy';
import DeactivateIcon from './Deactivate';
import WalletIcon from './Wallet';
import FilterIcon from './Filter';
import DownloadIcon from './Download';
import UploadFile from './UploadFile';
import DownloadFile from './DownloadFile';
import ListCheck from './ListCheck';
import Tree from './Tree';
import Circle from './Circle';
import EditMap from './EditMap';
import Square from './Square';
import UploadDocument from './UploadDocument';
import TitleSeparator from './TitleSeparator';
import DisconnectOutputCell from './DisconnectOutputCell';
import Archive from './Archive';
import LanguageIcon from './Language';
import Boat from './Boat';

const icons = {
  archive: memo(Archive),
  language: memo(LanguageIcon),
  delete: memo(DeleteIcon),
  duplicate: memo(DuplicateIcon),
  download: memo(DownloadIcon),
  edit: memo(EditIcon),
  view: memo(ViewIcon),
  more: memo(MoreIcon),
  test: memo(TestIcon),
  deploy: memo(DeployIcon),
  inactivate: memo(DeactivateIcon),
  circle: memo(Circle),
  editMap: memo(EditMap),
  square: memo(Square),
  titleSeparator: memo(TitleSeparator),
  disconnectOutputCell: memo(DisconnectOutputCell),
  uploadDocument: memo(UploadDocument),
  'darwin-user': memo(DarwinUserIcon),
  'user-outline': memo(UserOutlineIcon),
  'chevron-up': memo(ChevronUp),
  'end-of-flow': memo(EndOfFlow),
  'chevron-down': memo(ChevronDown),
  'user-placeholder': memo(UserPlaceholderIcon),
  'filter-icon': memo(FilterIcon),
  wallet: memo(WalletIcon),
  flag: memo(FlagIcon),
  packing: memo(PackingIcon),
  receiver: memo(ReceiverIcon),
  truck: memo(TruckIcon),
  cooling: memo(CoolingIcon),
  harvesting: memo(HarvestingIcon),
  'location-pin': memo(LocationPinIcon),
  plus: memo(PlusIcon),
  document: memo(DocumentIcon),
  'upload-file': memo(UploadFile),
  'download-file': memo(DownloadFile),
  'list-check': memo(ListCheck),
  tree: memo(Tree),
  boat: memo(Boat),
};

export default icons;
